import { Switch } from '@headlessui/react';
import React from 'react';

export interface iToggleProps {
  title: string;
  onSelect: (value: boolean) => void;
  value?: boolean;
}

export default function Toggle(props: iToggleProps) {
  const { onSelect, title, value } = props;
  const [enabled, setEnabled] = React.useState(value ?? false);

  const onChange = () => {
    onSelect(!enabled);
    setEnabled(!enabled);
  };

  return (
    <Switch.Group>
      <div className="flex items-center">
        <Switch.Label className="p-2">{title}</Switch.Label>
        <Switch
          checked={enabled}
          onChange={onChange}
          className={`${
            enabled ? 'e3d-toggle-active' : 'e3d-toggle-inactive'
          } e3d-toggle relative inline-flex shrink-0 focus:outline-none`}
        >
          <span
            className={`${
              enabled ? 'translate-x-[var(--ex3d-toggle-translateX)]' : 'translate-x-1'
            }  pointer-events-none inline-block h-[var(--ex3d-toggle-cycle-height)] w-[var(--ex3d-toggle-cycle-width)] rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
          />
        </Switch>
      </div>
    </Switch.Group>
  );
}
